<template>
  <div id="publication">
    <v-row>
      <v-col :cols="2" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0"></v-col>
      <v-col :cols="8" class="text-left no-left no-bottom no-top pa-0 ma-0">
        <DatePicker label="Date" :date="date" @choose="setDate" :disable_future="true" />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="2" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0"></v-col>
      <v-col :cols="8" class="text-left no-left no-bottom no-top pa-0 ma-0">
        <v-text-field outlined dense label="Publication" v-model="watch_publication" />
        <div id="publication__tooltip" v-if="all_publications.length > 0">
          <ul id="publication__tooltip--list">
            <li v-for="(p, i) in all_publications" v-bind:key="i" v-ripple="{ class: `primary--text` }"
              @click.prevent="choosePublication(p)">
              {{ p.publicationName }}
            </li>
          </ul>
        </div>
      </v-col>
      <v-col :cols="2" class="text-left no-left no-bottom no-top pa-0 ma-0">
        <v-progress-circular :width="3" :size="20" color="primary" indeterminate v-if="showSpinner"></v-progress-circular>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="2"></v-col>
      <v-col :cols="8">
        <v-btn small color="primary" @click.prevent="close()">Close</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from "./../../utilities/DatePicker";

export default {
  name: "AddPublication",
  data: () => ({
    date: "",
    publication: "",
    all_publications: [],
    watch_publication: "",
    publication_data: {
      publication_date: "",
      publication_id: null,
      publication_name: "",
    },
    working: false,
    showSpinner: false,
  }),
  components: {
    DatePicker,
  },
  methods: {
    setDate: function (d) {
      this.date = d.split(" ")[0];
    },
    close: function () {
      this.$emit("close", false);
    },
    choosePublication: function (p) {
      var view = this;
      //p.date = view.date
      let states_arr = view.$store.getters['ProductData/getStateProvince']
      view.publication_data.publication_date = view.date;
      view.publication_data.publication_id = p.publicationID;
      view.publication_data.publication_name = p.publicationName;
      if (!this.date) { alert("Please select the date.") }
      else {
        if (view.isSelected(p)) {
           alert("You are selecting already selected publication with same date.")
             view.$emit("close", true);
          return false;  
        } else {

          if (p.p_stateID) {

            states_arr.push(parseInt(p.p_stateID))
          }
        }
        states_arr = [...new Set(states_arr)];
        view.$store.dispatch('ProductData/setStateProvince', states_arr);

        if (!view.$store.getters['ProductData/getPrimaryCountry']) {
          view.$store.dispatch('ProductData/setPrimaryCountry', p.p_primary_country)
        }

        view.$store
          .dispatch("ProductData/setPublication", view.publication_data)
          .then(function () {
            view.close();
            return true;
          });
      }
    },
    isSelected: function (o) {
      var view = this,
        com = view.$store.getters['ProductData/getPublications']
      return com.find(e =>((e.publication_id === o.publicationID ) && (e.publication_date===view.date)))
    }
  },
  watch: {
    watch_publication: function (w) {
      var view = this;
      if (!view.working && w.length > 1) {
        view.working = true;
        view.all_publications = [];
        view.showSpinner = true;
        view
          .$fetch({
            url: view.$url("API") + "publications/" + w,
            type: "GET",
          }, {
            operation: 'view',
            vueScope: view
          })
          .then(function (o) {
            view.working = false;
            view.showSpinner = false;
            if (o !== null) {
              o.forEach(function (obj) {
                view.all_publications.push(obj);
              });
            }
          })
          .catch(function (e) {
            console.log(e);
            view.working = false;
            view.showSpinner = false;
          });
      } else {
        view.all_publications = [];
        view.showSpinner = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/publication'
</style>
